import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { MessageSquare, Inbox, Send, CheckCircle, XCircle, ThumbsUp, Loader2, Eye, Calendar, Users, Building2, FileText, AlertTriangle, Download, FileCheck, Trash2, History, ArrowRight, ArrowUpDown, ArrowUp, ArrowDown, Plus, File as FileIcon, User } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { ScrollArea } from '../../components/ui/scroll-area';
import { Checkbox } from '../../components/ui/checkbox';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../components/ui/alert-dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Communications = () => {
  const [activeTab, setActiveTab] = useState('inbox');
  const [inboxRequests, setInboxRequests] = useState([]);
  const [forwardedRequests, setForwardedRequests] = useState([]);
  const [approvedRequests, setApprovedRequests] = useState([]);
  const [rejectedRequests, setRejectedRequests] = useState([]);
  const [managementRejectedRequests, setManagementRejectedRequests] = useState([]);
  const [hrApprovedRequests, setHrApprovedRequests] = useState([]); // İK'nın onayladıkları
  const [hrRejectedRequests, setHrRejectedRequests] = useState([]); // İK'nın reddetikleri
  const [pendingDocRequests, setPendingDocRequests] = useState([]);
  const [respondedDocRequests, setRespondedDocRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  
  // Okunmamış sayaçları
  const [unreadCounts, setUnreadCounts] = useState({
    inbox: 0,
    forwarded: 0,
    management_rejected: 0,
    approved: 0,
    rejected: 0,
    hr_approved: 0,
    hr_rejected: 0,
    total: 0
  });
  
  // Detail modal
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  
  // Document detail modal
  const [docDetailModalOpen, setDocDetailModalOpen] = useState(false);
  const [selectedDocRequest, setSelectedDocRequest] = useState(null);
  const [selectedDocResponse, setSelectedDocResponse] = useState(null);
  
  // Action modal
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState('');
  const [actionNote, setActionNote] = useState('');
  
  // İzin onayı için gün seçimi
  const [showLeaveDayModal, setShowLeaveDayModal] = useState(false);
  const [selectedLeaveDays, setSelectedLeaveDays] = useState([]);
  const [selectedAttendanceStatus, setSelectedAttendanceStatus] = useState('annual');
  
  // Toplu seçim ve silme
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Sıralama
  const [sortField, setSortField] = useState('created_at');
  const [sortDirection, setSortDirection] = useState('desc'); // 'asc' veya 'desc'

  // TALEPLERİM - Kendi taleplerim
  const [myRequests, setMyRequests] = useState([]);
  const [myRequestsLoading, setMyRequestsLoading] = useState(false);
  const [createRequestModalOpen, setCreateRequestModalOpen] = useState(false);
  const [newRequestData, setNewRequestData] = useState({
    request_date: new Date().toISOString().split('T')[0],
    title: '',
    description: '',
    target_user_ids: []  // Çoklu seçim için array
  });
  const [pendingDocuments, setPendingDocuments] = useState([]);
  const [submittingRequest, setSubmittingRequest] = useState(false);
  const [requestTargetUsers, setRequestTargetUsers] = useState([]);
  const [loadingRequestUsers, setLoadingRequestUsers] = useState(false);
  const [requestUserSearchTerm, setRequestUserSearchTerm] = useState('');
  const [selectedMyRequest, setSelectedMyRequest] = useState(null);
  const [myRequestDetailModalOpen, setMyRequestDetailModalOpen] = useState(false);

  // Sıralama fonksiyonu
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Talepleri sırala
  const sortRequests = (requests) => {
    if (!requests || requests.length === 0) return [];
    
    return [...requests].sort((a, b) => {
      let aValue, bValue;
      
      switch (sortField) {
        case 'requester_name':
          aValue = (a.original_requester_name || a.requester_name || a.owner_name || '').toLowerCase();
          bValue = (b.original_requester_name || b.requester_name || b.owner_name || '').toLowerCase();
          break;
        case 'branch_name':
          aValue = (a.requester_branch_name || a.branch_name || '').toLowerCase();
          bValue = (b.requester_branch_name || b.branch_name || '').toLowerCase();
          break;
        case 'created_at':
          aValue = new Date(a.created_at || 0).getTime();
          bValue = new Date(b.created_at || 0).getTime();
          break;
        case 'status':
          aValue = (a.status || '').toLowerCase();
          bValue = (b.status || '').toLowerCase();
          break;
        default:
          aValue = a[sortField] || '';
          bValue = b[sortField] || '';
      }
      
      if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  };

  // Kullanıcı ID'sini al
  useEffect(() => {
    const token = localStorage.getItem('fortis_token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setCurrentUserId(payload.sub);
      } catch (e) {
        console.error('Token parse hatası:', e);
      }
    }
  }, []);

  // Bir talebin okunup okunmadığını kontrol et
  const isUnread = (request) => {
    if (!currentUserId || !request) return false;
    const readBy = request.read_by || {};
    return readBy[currentUserId] !== true;
  };

  // Durum seçenekleri
  const attendanceStatusOptions = [
    { value: 'present', label: 'İşe Geldi', color: 'bg-green-100 text-green-700 border-green-300' },
    { value: 'half_day', label: 'Yarım Gün', color: 'bg-blue-100 text-blue-700 border-blue-300' },
    { value: 'absent', label: 'Gelmedi', color: 'bg-red-100 text-red-700 border-red-300' },
    { value: 'paid_leave', label: 'Ücretli İzinli', color: 'bg-purple-100 text-purple-700 border-purple-300' },
    { value: 'unpaid_leave', label: 'Ücretsiz İzinli', color: 'bg-orange-100 text-orange-700 border-orange-300' },
    { value: 'sick', label: 'Raporlu', color: 'bg-yellow-100 text-yellow-700 border-yellow-300' },
    { value: 'annual', label: 'Yıllık İzin', color: 'bg-cyan-100 text-cyan-700 border-cyan-300' },
    { value: 'holiday', label: 'Resmi Tatil', color: 'bg-pink-100 text-pink-700 border-pink-300' }
  ];

  // Okundu olarak işaretle
  const markAsRead = useCallback(async () => {
    try {
      const token = localStorage.getItem('fortis_token');
      await fetch(`${BACKEND_URL}/api/notifications/mark-read?item_type=hr_request&mark_all=true&category=hr_inbox`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
    } catch (error) {
      console.error('Okundu işaretleme hatası:', error);
    }
  }, []);

  // Okunmamış sayaçlarını getir
  const fetchUnreadCounts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/hr/communications/unread-counts`);
      setUnreadCounts(res.data);
    } catch (error) {
      console.error('Okunmamış sayaçları yüklenemedi:', error);
    }
  }, []);

  // Tek bir talebi okundu işaretle
  const markRequestAsRead = useCallback(async (requestId) => {
    try {
      await axios.post(`${API}/hr/communications/mark-read/${requestId}`);
      fetchUnreadCounts(); // Sayaçları güncelle
    } catch (error) {
      console.error('Okundu işaretleme hatası:', error);
    }
  }, [fetchUnreadCounts]);

  useEffect(() => {
    fetchAllData();
    fetchUnreadCounts();
  }, [fetchUnreadCounts]);

  const fetchAllData = () => {
    fetchInboxRequests();
    fetchForwardedRequests();
    fetchApprovedRequests();
    fetchRejectedRequests();
    fetchManagementRejectedRequests();
    fetchHrApprovedRequests();
    fetchHrRejectedRequests();
    fetchPendingDocRequests();
    fetchRespondedDocRequests();
    fetchMyRequests();
  };

  // TALEPLERİM - Kendi oluşturduğum talepleri getir
  const fetchMyRequests = async () => {
    setMyRequestsLoading(true);
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${API}/hr/requests/my`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setMyRequests(data);
      }
    } catch (error) {
      console.error('Taleplerim yüklenemedi:', error);
    }
    setMyRequestsLoading(false);
  };

  // Talep oluşturma için kullanıcı listesini yükle
  const fetchRequestTargetUsers = async () => {
    setLoadingRequestUsers(true);
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${API}/hr/users-for-request`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setRequestTargetUsers(data.users || []);
      }
    } catch (error) {
      console.error('Kullanıcılar yüklenemedi:', error);
    } finally {
      setLoadingRequestUsers(false);
    }
  };

  // Filtrelenmiş talep hedef kullanıcıları
  const filteredRequestTargetUsers = requestTargetUsers.filter(user => 
    user.name?.toLowerCase().includes(requestUserSearchTerm.toLowerCase()) ||
    user.position?.toLowerCase().includes(requestUserSearchTerm.toLowerCase()) ||
    user.email?.toLowerCase().includes(requestUserSearchTerm.toLowerCase())
  );

  // Modal açılınca kullanıcıları yükle
  const openCreateRequestModal = () => {
    setNewRequestData({
      request_date: new Date().toISOString().split('T')[0],
      title: '',
      description: '',
      target_user_ids: []
    });
    setPendingDocuments([]);
    setRequestUserSearchTerm('');
    fetchRequestTargetUsers();
    setCreateRequestModalOpen(true);
  };

  // Kullanıcı seçimi toggle
  const toggleUserSelection = (userId) => {
    setNewRequestData(prev => ({
      ...prev,
      target_user_ids: prev.target_user_ids.includes(userId)
        ? prev.target_user_ids.filter(id => id !== userId)
        : [...prev.target_user_ids, userId]
    }));
  };

  // Yeni talep oluştur
  const handleCreateRequest = async () => {
    if (!newRequestData.title.trim()) {
      toast.error('Talep başlığı gerekli');
      return;
    }
    if (!newRequestData.description.trim()) {
      toast.error('Talep açıklaması gerekli');
      return;
    }
    if (newRequestData.target_user_ids.length === 0) {
      toast.error('En az bir kişi seçmelisiniz');
      return;
    }

    setSubmittingRequest(true);
    try {
      const token = localStorage.getItem('fortis_token');
      
      // FormData ile gönder (belgeler için)
      const formData = new FormData();
      formData.append('category', 'hr_request');  // İK talebi olarak işaretle
      formData.append('title', newRequestData.title);
      formData.append('description', newRequestData.description);
      formData.append('priority', 'normal');
      formData.append('request_date', newRequestData.request_date);
      
      // Hedef kullanıcılar (çoklu)
      formData.append('target_user_ids', JSON.stringify(newRequestData.target_user_ids));
      
      // Belgeleri ekle
      pendingDocuments.forEach((file) => {
        formData.append('documents', file);
      });

      const response = await fetch(`${API}/hr/requests`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (response.ok) {
        toast.success('Talep başarıyla oluşturuldu');
        setCreateRequestModalOpen(false);
        setNewRequestData({
          request_date: new Date().toISOString().split('T')[0],
          title: '',
          description: '',
          target_user_ids: []
        });
        setPendingDocuments([]);
        fetchMyRequests();
      } else {
        const error = await response.json();
        toast.error(error.detail || 'Talep oluşturulamadı');
      }
    } catch (error) {
      console.error('Talep oluşturma hatası:', error);
      toast.error('Talep oluşturulamadı');
    }
    setSubmittingRequest(false);
  };

  // Belge seçimi
  const handleDocumentSelect = (e) => {
    const files = Array.from(e.target.files);
    setPendingDocuments(prev => [...prev, ...files]);
    
    // İlk dosyanın adını iş konusu olarak kullan
    if (files.length > 0 && !newRequestData.title) {
      const fileName = files[0].name;
      const titleFromFile = fileName.replace(/\.[^/.]+$/, "");
      setNewRequestData(prev => ({...prev, title: titleFromFile}));
    }
  };

  // Bekleyen belgeyi kaldır
  const removeDocument = (index) => {
    setPendingDocuments(prev => prev.filter((_, i) => i !== index));
  };

  // TALEPLERİM filtreleme - Bekleyen
  const getMyPendingRequests = () => {
    if (!myRequests) return [];
    return myRequests.filter(req => 
      req.status === 'pending' || 
      req.status === 'pending_muhasebe' ||
      req.status === 'forwarded_to_hr' || 
      req.status === 'forwarded_to_dept' ||
      req.status === 'forwarded_to_user'
    );
  };

  // TALEPLERİM filtreleme - Kabul Edilen
  const getMyApprovedRequests = () => {
    if (!myRequests) return [];
    return myRequests.filter(req => 
      req.status === 'approved' || 
      req.status === 'approved_by_hr' || 
      req.status === 'approved_by_dept' ||
      req.status === 'answered'
    );
  };

  // TALEPLERİM filtreleme - Red Edilen
  const getMyRejectedRequests = () => {
    if (!myRequests) return [];
    return myRequests.filter(req => 
      req.status === 'rejected' || 
      req.status === 'rejected_by_hr' || 
      req.status === 'rejected_by_dept' || 
      req.status === 'rejected_by_branch'
    );
  };

  // Kategori başlıkları
  const getCategoryTitles = (category) => {
    switch(category) {
      case 'ik':
        return ['İzin Talebi', 'Fazla Mesai Talebi', 'Rapor Talebi', 'Evrak Talebi', 'Diğer'];
      case 'satin_alma':
        return ['Malzeme Talebi', 'Hizmet Talebi', 'Ekipman Talebi', 'Diğer'];
      case 'muhasebe':
        return ['Avans Talebi', 'Masraf Bildirimi', 'Fatura Talebi', 'Diğer'];
      case 'idari':
        return ['Bakım/Onarım Talebi', 'Temizlik Talebi', 'Güvenlik Talebi', 'Diğer'];
      case 'genel':
        return ['Öneri', 'Şikayet', 'Bilgi Talebi', 'Diğer'];
      default:
        return ['Diğer'];
    }
  };
  
  const fetchPendingDocRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/document-requests/pending`);
      setPendingDocRequests(res.data || []);
    } catch (error) {
      console.error('İstenen belgeler yüklenemedi:', error);
    }
  };
  
  const fetchRespondedDocRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/document-requests/responded`);
      setRespondedDocRequests(res.data || []);
    } catch (error) {
      console.error('Gelen belgeler yüklenemedi:', error);
    }
  };

  const fetchInboxRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/inbox`);
      setInboxRequests(res.data || []);
    } catch (error) {
      console.error('Gelen talepler yüklenemedi:', error);
    }
  };

  const fetchForwardedRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/forwarded`);
      setForwardedRequests(res.data || []);
    } catch (error) {
      console.error('Yönetime iletilen talepler yüklenemedi:', error);
    }
  };

  const fetchApprovedRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/approved`);
      setApprovedRequests(res.data || []);
    } catch (error) {
      console.error('Onaylanan talepler yüklenemedi:', error);
    }
  };

  const fetchRejectedRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/rejected`);
      setRejectedRequests(res.data || []);
    } catch (error) {
      console.error('Red edilen talepler yüklenemedi:', error);
    }
  };

  const fetchManagementRejectedRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/management-rejected`);
      setManagementRejectedRequests(res.data || []);
    } catch (error) {
      console.error('Yönetim tarafından red edilen talepler yüklenemedi:', error);
    }
  };

  const fetchHrApprovedRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/hr-approved`);
      setHrApprovedRequests(res.data || []);
    } catch (error) {
      console.error('İK onayladığı talepler yüklenemedi:', error);
    }
  };

  const fetchHrRejectedRequests = async () => {
    try {
      const res = await axios.get(`${API}/hr/hr-requests/hr-rejected`);
      setHrRejectedRequests(res.data || []);
    } catch (error) {
      console.error('İK reddettiği talepler yüklenemedi:', error);
    }
  };

  const handleViewRequest = (request) => {
    setSelectedRequest(request);
    setDetailModalOpen(true);
    // Talep görüntülendiğinde okundu olarak işaretle
    markRequestAsRead(request.id);
  };

  const openActionModal = (type) => {
    setActionType(type);
    setActionNote('');
    setShowActionModal(true);
  };

  const handleAction = async () => {
    if (actionType === 'reject' && !actionNote.trim()) {
      toast.error('Red nedeni gerekli');
      return;
    }
    
    setLoading(true);
    try {
      if (actionType === 'approve_overtime') {
        // Fazla mesai talebini doğrudan onayla
        await axios.post(
          `${API}/hr/hr-requests/${selectedRequest.id}/approve-overtime?note=${encodeURIComponent(actionNote || '')}`
        );
        toast.success('Fazla mesai onaylandı ve tabloya işlendi');
      } else if (actionType === 'approve_leave') {
        // İzin talebini seçilen günlerle ve durumla onayla
        if (selectedLeaveDays.length === 0) {
          toast.error('Lütfen en az bir izin günü seçin');
          setLoading(false);
          return;
        }
        await axios.post(`${API}/hr/hr-requests/${selectedRequest.id}/approve-leave`, {
          selected_days: selectedLeaveDays,
          attendance_status: selectedAttendanceStatus,
          note: actionNote || ''
        });
        toast.success(`İzin onaylandı ve ${selectedLeaveDays.length} gün "${attendanceStatusOptions.find(o => o.value === selectedAttendanceStatus)?.label}" olarak işlendi`);
        setShowLeaveDayModal(false);
        setSelectedLeaveDays([]);
        setSelectedAttendanceStatus('annual');
      } else if (actionType === 'hr_approve') {
        // İK onayı - yönetime iletmeden doğrudan onayla
        await axios.post(
          `${API}/hr/hr-requests/${selectedRequest.id}/action?action=hr_approve&note=${encodeURIComponent(actionNote || '')}`
        );
        toast.success('Talep İK tarafından onaylandı');
      } else {
        await axios.post(
          `${API}/hr/hr-requests/${selectedRequest.id}/action?action=${actionType}&note=${encodeURIComponent(actionNote || '')}`
        );
        toast.success(actionType === 'forward_management' ? 'Talep onaylandı ve yönetime iletildi' : 'Talep reddedildi');
      }
      
      setShowActionModal(false);
      setDetailModalOpen(false);
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'İşlem başarısız');
    } finally {
      setLoading(false);
    }
  };

  // İzin onay modalını aç ve günleri hesapla
  const openLeaveApprovalModal = (request) => {
    // Handle nested form_data structure
    const formData = request.form_data?.form_data || request.form_data || {};
    const startDate = formData.izinBaslangic;
    const endDate = formData.izinBitis;
    const izinTuru = formData.izinTuru;
    
    // İzin türüne göre varsayılan durumu ayarla
    const statusMap = {
      'yillik': 'annual',
      'mazeret': 'paid_leave',
      'ucretsiz': 'unpaid_leave'
    };
    setSelectedAttendanceStatus(statusMap[izinTuru] || 'annual');
    
    if (startDate && endDate) {
      const days = [];
      const current = new Date(startDate);
      const end = new Date(endDate);
      
      while (current <= end) {
        days.push(current.toISOString().split('T')[0]);
        current.setDate(current.getDate() + 1);
      }
      setSelectedLeaveDays(days);
    }
    
    setSelectedRequest(request);
    setActionNote('');
    setShowLeaveDayModal(true);
  };

  // Gün seçimini toggle et
  const toggleLeaveDay = (day) => {
    if (selectedLeaveDays.includes(day)) {
      setSelectedLeaveDays(selectedLeaveDays.filter(d => d !== day));
    } else {
      setSelectedLeaveDays([...selectedLeaveDays, day].sort());
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'pending_branch': { label: 'Şubede Bekliyor', className: 'bg-yellow-100 text-yellow-800' },
      'pending_hr': { label: 'İnceleniyor', className: 'bg-blue-100 text-blue-800' },
      'pending_management': { label: 'Yönetimde', className: 'bg-purple-100 text-purple-800' },
      'approved': { label: 'Onaylandı', className: 'bg-green-100 text-green-800' },
      'rejected_by_branch': { label: 'Şube Reddetti', className: 'bg-red-100 text-red-800' },
      'rejected_by_hr': { label: 'Red Edildi', className: 'bg-red-100 text-red-800' },
      'rejected_by_management': { label: 'Yönetim Reddetti', className: 'bg-red-100 text-red-800' }
    };
    const statusInfo = statusMap[status] || { label: status, className: 'bg-gray-100 text-gray-800' };
    return <Badge className={statusInfo.className}>{statusInfo.label}</Badge>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      return new Date(dateStr).toLocaleDateString('tr-TR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    } catch {
      return dateStr;
    }
  };

  // Seçim fonksiyonları
  const toggleSelectRequest = (requestId) => {
    setSelectedRequests(prev => 
      prev.includes(requestId) 
        ? prev.filter(id => id !== requestId)
        : [...prev, requestId]
    );
  };

  const toggleSelectAll = (requests) => {
    const requestIds = requests.map(r => r.id);
    const allSelected = requestIds.every(id => selectedRequests.includes(id));
    
    if (allSelected) {
      // Hepsini kaldır
      setSelectedRequests(prev => prev.filter(id => !requestIds.includes(id)));
    } else {
      // Hepsini ekle
      setSelectedRequests(prev => [...new Set([...prev, ...requestIds])]);
    }
  };

  const isAllSelected = (requests) => {
    if (requests.length === 0) return false;
    return requests.every(r => selectedRequests.includes(r.id));
  };

  const getSelectedCountForTab = (requests) => {
    return requests.filter(r => selectedRequests.includes(r.id)).length;
  };

  // Toplu silme fonksiyonu
  const handleBulkDelete = async () => {
    if (selectedRequests.length === 0) {
      toast.error('Silinecek talep seçilmedi');
      return;
    }

    setDeleteLoading(true);
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${API}/hr/hr-requests/bulk-delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ request_ids: selectedRequests })
      });

      if (response.ok) {
        const result = await response.json();
        toast.success(result.message || `${selectedRequests.length} talep silindi`);
        setSelectedRequests([]);
        setShowDeleteDialog(false);
        fetchAllData();
        fetchUnreadCounts();
      } else {
        const error = await response.json();
        toast.error(error.detail || 'Silme işlemi başarısız');
      }
    } catch (error) {
      toast.error('Silme işlemi sırasında hata oluştu');
      console.error('Bulk delete error:', error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const RequestTable = ({ requests, testId, emptyMessage, emptyIcon: EmptyIcon, showRejectionReason = false }) => {
    const selectedCount = getSelectedCountForTab(requests);
    
    return (
    <Card className="border-[hsl(var(--border))]">
      <CardContent className="pt-6">
        {/* Seçim aksiyonları */}
        {selectedCount > 0 && (
          <div className="flex items-center justify-between mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <span className="text-sm font-medium text-red-700">
              {selectedCount} talep seçildi
            </span>
            <Button
              variant="destructive"
              size="sm"
              onClick={() => setShowDeleteDialog(true)}
              data-testid="bulk-delete-btn"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Seçilenleri Sil
            </Button>
          </div>
        )}
        
        {requests.length === 0 ? (
          <div className="text-center py-16 text-[hsl(var(--muted-foreground))]" data-testid={`${testId}-empty`}>
            <EmptyIcon className="h-16 w-16 mx-auto mb-4 opacity-30" />
            <p className="font-medium">{emptyMessage}</p>
          </div>
        ) : (
          <ScrollArea className="h-[500px]">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[50px]">
                    <Checkbox
                      checked={isAllSelected(requests)}
                      onCheckedChange={() => toggleSelectAll(requests)}
                      data-testid={`${testId}-select-all`}
                    />
                  </TableHead>
                  <TableHead className="w-[40px]"></TableHead>
                  <TableHead>Form No</TableHead>
                  <TableHead>Form Türü</TableHead>
                  <TableHead 
                    className="cursor-pointer hover:bg-gray-100 select-none"
                    onClick={() => handleSort('requester_name')}
                  >
                    <div className="flex items-center gap-1">
                      Talep Eden
                      {sortField === 'requester_name' ? (
                        sortDirection === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                      ) : (
                        <ArrowUpDown className="h-4 w-4 text-gray-400" />
                      )}
                    </div>
                  </TableHead>
                  <TableHead 
                    className="cursor-pointer hover:bg-gray-100 select-none"
                    onClick={() => handleSort('branch_name')}
                  >
                    <div className="flex items-center gap-1">
                      Şube
                      {sortField === 'branch_name' ? (
                        sortDirection === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                      ) : (
                        <ArrowUpDown className="h-4 w-4 text-gray-400" />
                      )}
                    </div>
                  </TableHead>
                  <TableHead 
                    className="cursor-pointer hover:bg-gray-100 select-none"
                    onClick={() => handleSort('created_at')}
                  >
                    <div className="flex items-center gap-1">
                      Tarih
                      {sortField === 'created_at' ? (
                        sortDirection === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                      ) : (
                        <ArrowUpDown className="h-4 w-4 text-gray-400" />
                      )}
                    </div>
                  </TableHead>
                  <TableHead 
                    className="cursor-pointer hover:bg-gray-100 select-none"
                    onClick={() => handleSort('status')}
                  >
                    <div className="flex items-center gap-1">
                      Durum
                      {sortField === 'status' ? (
                        sortDirection === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
                      ) : (
                        <ArrowUpDown className="h-4 w-4 text-gray-400" />
                      )}
                    </div>
                  </TableHead>
                  <TableHead>İşlem</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {sortRequests(requests).map((request) => {
                  const unread = isUnread(request);
                  const isSelected = selectedRequests.includes(request.id);
                  return (
                    <TableRow 
                      key={request.id} 
                      data-testid={`${testId}-row-${request.id}`}
                      className={`${unread ? 'bg-blue-50/70 hover:bg-blue-100/70 font-medium' : ''} ${isSelected ? 'bg-red-50/50' : ''}`}
                    >
                      <TableCell className="w-[50px] p-2">
                        <Checkbox
                          checked={isSelected}
                          onCheckedChange={() => toggleSelectRequest(request.id)}
                          data-testid={`select-request-${request.id}`}
                        />
                      </TableCell>
                      <TableCell className="w-[40px] p-2">
                        {unread && (
                          <div className="flex items-center justify-center">
                            <span className="relative flex h-3 w-3">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                              <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
                            </span>
                          </div>
                        )}
                      </TableCell>
                      <TableCell className={`font-mono text-sm ${unread ? 'text-blue-700 font-semibold' : ''}`}>
                        {request.form_number || 'N/A'}
                      </TableCell>
                      <TableCell className={unread ? 'font-semibold' : 'font-medium'}>
                        {request.form_template_name}
                      </TableCell>
                      <TableCell className={unread ? 'font-semibold' : ''}>
                        {request.original_requester_name || request.requester_name || request.owner_name || 'Bilinmiyor'}
                      </TableCell>
                      <TableCell className={`text-sm ${unread ? 'font-semibold' : ''}`}>
                        {request.requester_branch_name || request.branch_name || '-'}
                      </TableCell>
                      <TableCell className={`text-sm ${unread ? 'font-semibold' : ''}`}>
                        {formatDate(request.created_at)}
                      </TableCell>
                      <TableCell>{getStatusBadge(request.status)}</TableCell>
                      <TableCell>
                        <Button
                          variant={unread ? "default" : "ghost"}
                          size="sm"
                          onClick={() => handleViewRequest(request)}
                          data-testid={`view-request-${request.id}`}
                          className={unread ? 'bg-blue-600 hover:bg-blue-700 text-white' : ''}
                        >
                          <Eye className="h-4 w-4 mr-1" />
                          {unread ? 'Görüntüle' : ''}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </ScrollArea>
        )}
      </CardContent>
    </Card>
  )};


  return (
    <div className="space-y-6" data-testid="hr-communications">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[hsl(var(--foreground))]">
            İK Talep Yönetimi
          </h1>
          <p className="text-[hsl(var(--muted-foreground))]">
            Çalışan taleplerini inceleyin ve işlem yapın
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="flex flex-wrap gap-2 p-3 bg-gray-100 dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl w-full max-w-7xl h-auto">
          <TabsTrigger value="inbox" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-amber-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-inbox">
            <Inbox className="h-4 w-4" />
            Gelen
            {unreadCounts.inbox > 0 && (
              <Badge variant="destructive" className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs animate-pulse">
                {unreadCounts.inbox}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="my-requests" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-amber-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-my-requests">
            <User className="h-4 w-4" />
            Taleplerim
            {getMyPendingRequests().length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-amber-500">
                {getMyPendingRequests().length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="my-approved" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-green-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-my-approved">
            <CheckCircle className="h-4 w-4" />
            Kabul Edilenler
            {getMyApprovedRequests().length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-green-500">
                {getMyApprovedRequests().length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="my-rejected" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-red-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-my-rejected">
            <XCircle className="h-4 w-4" />
            Red Edilenler
            {getMyRejectedRequests().length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-red-500">
                {getMyRejectedRequests().length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="hr-approved" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-emerald-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-hr-approved">
            <ThumbsUp className="h-4 w-4" />
            Onayladıklarım
            {hrApprovedRequests.length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-emerald-500">
                {hrApprovedRequests.length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="hr-rejected" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-red-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-hr-rejected">
            <XCircle className="h-4 w-4" />
            Red Ettiklerim
            {hrRejectedRequests.length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-red-500">
                {hrRejectedRequests.length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="forwarded" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-blue-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-forwarded">
            <Send className="h-4 w-4" />
            Yönetime İletilen
            {unreadCounts.forwarded > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-blue-500">
                {unreadCounts.forwarded}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="management-rejected" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-orange-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-management-rejected">
            <AlertTriangle className="h-4 w-4" />
            Yönetim Red
            {unreadCounts.management_rejected > 0 && (
              <Badge variant="destructive" className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs animate-pulse">
                {unreadCounts.management_rejected}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="approved" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-green-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-approved">
            <CheckCircle className="h-4 w-4" />
            Yönetim Onaylanan
            {unreadCounts.approved > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-green-500">
                {unreadCounts.approved}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="doc-pending" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-orange-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-doc-pending">
            <FileText className="h-4 w-4" />
            İstenen Evraklar
            {pendingDocRequests.length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-orange-500">
                {pendingDocRequests.length}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="doc-responded" className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-transparent data-[state=active]:bg-white data-[state=active]:border-green-400 data-[state=active]:shadow-md dark:data-[state=active]:bg-gray-900 transition-all" data-testid="tab-doc-responded">
            <FileCheck className="h-4 w-4" />
            Gelen Evrak
            {respondedDocRequests.length > 0 && (
              <Badge className="ml-1 h-5 min-w-[20px] px-1.5 flex items-center justify-center text-xs bg-green-500">
                {respondedDocRequests.length}
              </Badge>
            )}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="inbox">
          <RequestTable 
            requests={inboxRequests} 
            testId="inbox-requests"
            emptyMessage="Bekleyen talep bulunmuyor"
            emptyIcon={Inbox}
          />
        </TabsContent>

        {/* TALEPLERİM - Bekleyen */}
        <TabsContent value="my-requests">
          <Card className="border-[hsl(var(--border))]">
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="text-lg flex items-center gap-2">
                <User className="h-5 w-5" />
                Taleplerim
              </CardTitle>
              <Button onClick={openCreateRequestModal} className="bg-violet-600 hover:bg-violet-700" data-testid="create-request-btn">
                <Plus className="h-4 w-4 mr-2" />
                Talep Ekle
              </Button>
            </CardHeader>
            <CardContent>
              {myRequestsLoading ? (
                <div className="text-center py-16">
                  <Loader2 className="h-12 w-12 mx-auto mb-4 animate-spin text-violet-500" />
                  <p>Talepler yükleniyor...</p>
                </div>
              ) : getMyPendingRequests().length === 0 ? (
                <div className="text-center py-16 text-[hsl(var(--muted-foreground))]">
                  <User className="h-16 w-16 mx-auto mb-4 opacity-30" />
                  <p className="font-medium">Bekleyen talebiniz bulunmuyor</p>
                  <p className="text-sm mt-2">Yeni bir talep oluşturmak için "Talep Ekle" butonuna tıklayın</p>
                </div>
              ) : (
                <ScrollArea className="h-[500px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Talep No</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Gönderildiği Kişiler</TableHead>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Durum</TableHead>
                        <TableHead>İşlem</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {getMyPendingRequests().map((req) => (
                        <TableRow key={req.id}>
                          <TableCell className="font-mono text-sm">{req.request_no || '-'}</TableCell>
                          <TableCell className="font-medium">{req.title}</TableCell>
                          <TableCell>
                            <div className="flex flex-wrap gap-1">
                              {req.target_user_names?.map((name, idx) => (
                                <Badge key={idx} variant="outline" className="text-xs bg-violet-50">
                                  {name}
                                </Badge>
                              )) || '-'}
                            </div>
                          </TableCell>
                          <TableCell className="text-sm">
                            {req.request_date ? new Date(req.request_date).toLocaleDateString('tr-TR') : 
                             new Date(req.created_at).toLocaleDateString('tr-TR')}
                          </TableCell>
                          <TableCell>
                            <Badge variant="outline" className="bg-yellow-100 text-yellow-800">
                              Bekliyor
                            </Badge>
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => {
                                setSelectedMyRequest(req);
                                setMyRequestDetailModalOpen(true);
                              }}
                              className="text-violet-600 hover:text-violet-700 hover:bg-violet-50"
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Detay
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* TALEPLERİM - Kabul Edilenler */}
        <TabsContent value="my-approved">
          <Card className="border-[hsl(var(--border))]">
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-green-600" />
                Kabul Edilen Taleplerim
              </CardTitle>
            </CardHeader>
            <CardContent>
              {getMyApprovedRequests().length === 0 ? (
                <div className="text-center py-16 text-[hsl(var(--muted-foreground))]">
                  <CheckCircle className="h-16 w-16 mx-auto mb-4 opacity-30" />
                  <p className="font-medium">Kabul edilen talebiniz bulunmuyor</p>
                </div>
              ) : (
                <ScrollArea className="h-[500px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Kategori</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Öncelik</TableHead>
                        <TableHead>Durum</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {getMyApprovedRequests().map((req) => (
                        <TableRow key={req.id}>
                          <TableCell>
                            <Badge variant="outline">{req.category}</Badge>
                          </TableCell>
                          <TableCell className="font-medium">{req.title}</TableCell>
                          <TableCell className="text-sm">
                            {new Date(req.created_at).toLocaleDateString('tr-TR')}
                          </TableCell>
                          <TableCell>
                            <Badge className={
                              req.priority === 'urgent' ? 'bg-red-500' :
                              req.priority === 'high' ? 'bg-orange-500' :
                              req.priority === 'normal' ? 'bg-blue-500' : 'bg-gray-500'
                            }>
                              {req.priority === 'urgent' ? 'Acil' :
                               req.priority === 'high' ? 'Yüksek' :
                               req.priority === 'normal' ? 'Normal' : 'Düşük'}
                            </Badge>
                          </TableCell>
                          <TableCell>
                            <Badge className="bg-green-100 text-green-800">
                              Kabul Edildi
                            </Badge>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* TALEPLERİM - Red Edilenler */}
        <TabsContent value="my-rejected">
          <Card className="border-[hsl(var(--border))]">
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2">
                <XCircle className="h-5 w-5 text-red-600" />
                Red Edilen Taleplerim
              </CardTitle>
            </CardHeader>
            <CardContent>
              {getMyRejectedRequests().length === 0 ? (
                <div className="text-center py-16 text-[hsl(var(--muted-foreground))]">
                  <XCircle className="h-16 w-16 mx-auto mb-4 opacity-30" />
                  <p className="font-medium">Red edilen talebiniz bulunmuyor</p>
                </div>
              ) : (
                <ScrollArea className="h-[500px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Kategori</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Red Nedeni</TableHead>
                        <TableHead>Durum</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {getMyRejectedRequests().map((req) => (
                        <TableRow key={req.id}>
                          <TableCell>
                            <Badge variant="outline">{req.category}</Badge>
                          </TableCell>
                          <TableCell className="font-medium">{req.title}</TableCell>
                          <TableCell className="text-sm">
                            {new Date(req.created_at).toLocaleDateString('tr-TR')}
                          </TableCell>
                          <TableCell className="text-sm text-red-600 max-w-[200px] truncate">
                            {req.rejection_note || req.hr_note || '-'}
                          </TableCell>
                          <TableCell>
                            <Badge className="bg-red-100 text-red-800">
                              Red Edildi
                            </Badge>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="hr-approved">
          <RequestTable 
            requests={hrApprovedRequests} 
            testId="hr-approved-requests"
            emptyMessage="Onayladığınız talep bulunmuyor"
            emptyIcon={ThumbsUp}
          />
        </TabsContent>

        <TabsContent value="hr-rejected">
          <RequestTable 
            requests={hrRejectedRequests} 
            testId="hr-rejected-requests"
            emptyMessage="Reddettiğiniz talep bulunmuyor"
            emptyIcon={XCircle}
            showRejectionReason={true}
          />
        </TabsContent>

        <TabsContent value="forwarded">
          <RequestTable 
            requests={forwardedRequests} 
            testId="forwarded-requests"
            emptyMessage="Yönetime iletilen talep bulunmuyor"
            emptyIcon={Send}
          />
        </TabsContent>

        <TabsContent value="management-rejected">
          <RequestTable 
            requests={managementRejectedRequests} 
            testId="management-rejected-requests"
            emptyMessage="Yönetim tarafından reddedilen talep bulunmuyor"
            emptyIcon={AlertTriangle}
            showRejectionReason={true}
          />
        </TabsContent>

        <TabsContent value="approved">
          <RequestTable 
            requests={approvedRequests} 
            testId="approved-requests"
            emptyMessage="Yönetim tarafından onaylanan talep bulunmuyor"
            emptyIcon={CheckCircle}
          />
        </TabsContent>

        <TabsContent value="doc-pending">
          <Card className="border-[hsl(var(--border))]">
            <CardContent className="pt-6">
              {pendingDocRequests.length === 0 ? (
                <div className="text-center py-16 text-[hsl(var(--muted-foreground))]">
                  <FileText className="h-16 w-16 mx-auto mb-4 opacity-30" />
                  <p className="font-medium">Bekleyen belge talebi bulunmuyor</p>
                </div>
              ) : (
                <ScrollArea className="h-[500px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Belge Başlığı</TableHead>
                        <TableHead>Hedef Çalışan</TableHead>
                        <TableHead>Gönderilme Tarihi</TableHead>
                        <TableHead>Durum</TableHead>
                        <TableHead>İşlem</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {pendingDocRequests.map((doc) => (
                        <TableRow key={doc.id}>
                          <TableCell className="font-medium">{doc.title}</TableCell>
                          <TableCell>{(doc.target_employee_ids || []).length} kişi</TableCell>
                          <TableCell className="text-sm">
                            {new Date(doc.created_at).toLocaleDateString('tr-TR')}
                          </TableCell>
                          <TableCell>
                            <Badge variant="outline" className="bg-yellow-100 text-yellow-800">
                              Bekliyor
                            </Badge>
                          </TableCell>
                          <TableCell>
                            <Button 
                              variant="ghost" 
                              size="sm"
                              onClick={() => {
                                setSelectedDocRequest(doc);
                                setSelectedDocResponse(null);
                                setDocDetailModalOpen(true);
                              }}
                              data-testid={`view-doc-pending-${doc.id}`}
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Görüntüle
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="doc-responded">
          <Card className="border-[hsl(var(--border))]">
            <CardContent className="pt-6">
              {respondedDocRequests.length === 0 ? (
                <div className="text-center py-16 text-[hsl(var(--muted-foreground))]">
                  <FileCheck className="h-16 w-16 mx-auto mb-4 opacity-30" />
                  <p className="font-medium">Henüz cevaplanan belge talebi yok</p>
                </div>
              ) : (
                <ScrollArea className="h-[500px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Belge Başlığı</TableHead>
                        <TableHead>Cevap Veren</TableHead>
                        <TableHead>Cevap Tarihi</TableHead>
                        <TableHead>Belgeler</TableHead>
                        <TableHead>İşlem</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {respondedDocRequests.map((doc) => (
                        Object.entries(doc.responses || {}).map(([empId, response]) => (
                          <TableRow key={`${doc.id}-${empId}`}>
                            <TableCell className="font-medium">{doc.title}</TableCell>
                            <TableCell>{response.employee_name || empId}</TableCell>
                            <TableCell className="text-sm">
                              {response.responded_at ? new Date(response.responded_at).toLocaleDateString('tr-TR') : '-'}
                            </TableCell>
                            <TableCell>
                              {(response.documents || []).length > 0 ? (
                                <Badge className="bg-green-100 text-green-800">
                                  {response.documents.length} dosya
                                </Badge>
                              ) : (
                                <Badge variant="outline">Dosya yok</Badge>
                              )}
                            </TableCell>
                            <TableCell>
                              <Button 
                                variant="ghost" 
                                size="sm"
                                onClick={() => {
                                  setSelectedDocRequest(doc);
                                  setSelectedDocResponse({ ...response, employeeId: empId });
                                  setDocDetailModalOpen(true);
                                }}
                                data-testid={`view-doc-response-${doc.id}-${empId}`}
                              >
                                <Eye className="h-4 w-4 mr-1" />
                                Görüntüle
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Request Detail Modal */}
      <Dialog open={detailModalOpen} onOpenChange={setDetailModalOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-3">
              <FileText className="h-5 w-5" />
              {selectedRequest?.form_template_name}
              <span className="text-sm font-mono text-[hsl(var(--muted-foreground))] ml-2">
                {selectedRequest?.form_number}
              </span>
            </DialogTitle>
            <DialogDescription>
              Talep detaylarını görüntüleyin ve işlem yapın
            </DialogDescription>
          </DialogHeader>
          
          {selectedRequest && (
            <div className="space-y-4 py-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Talep Eden</Label>
                  <p className="font-medium">{selectedRequest.original_requester_name || selectedRequest.requester_name || selectedRequest.owner_name || 'Bilinmiyor'}</p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Şube</Label>
                  <p className="font-medium">{selectedRequest.requester_branch_name || selectedRequest.branch_name || '-'}</p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Talep Tarihi</Label>
                  <p className="font-medium">{formatDate(selectedRequest.created_at)}</p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Form No</Label>
                  <p className="font-mono">{selectedRequest.form_number || 'N/A'}</p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Durum</Label>
                  <div className="mt-1">{getStatusBadge(selectedRequest.status)}</div>
                </div>
              </div>
              
              {/* Orijinal Açıklama - İlk Talep */}
              {(selectedRequest.description || selectedRequest.original_description) && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
                    <FileText className="h-4 w-4" />
                    Talep Açıklaması
                  </Label>
                  <div className="mt-2 bg-blue-50 p-3 rounded-lg border border-blue-100">
                    <p className="text-sm text-gray-700 whitespace-pre-wrap">
                      {selectedRequest.original_description || selectedRequest.description}
                    </p>
                  </div>
                </div>
              )}

              {/* Form Data - Formatted Display */}
              <div className="border-t pt-4">
                <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Form Detayları
                </Label>
                <div className="mt-2 space-y-3 bg-[hsl(var(--muted))] p-4 rounded-lg">
                  {selectedRequest.form_data && (() => {
                    // Handle nested form_data structure
                    const formData = selectedRequest.form_data.form_data || selectedRequest.form_data;
                    
                    // Fields to hide from display (technical fields)
                    const hiddenFields = ['uploaded_file', 'form_type', 'form_data', 'mesaiFormDosya', 'formOlusturmaTarihi'];
                    
                    // Label mappings for better display
                    const labelMap = {
                      mesaiTarihi: 'Mesai Tarihi',
                      mesaiSaati: 'Mesai Saati',
                      mesaiGunu: 'Mesai Türü',
                      mesaiNedeni: 'Mesai Nedeni',
                      amount: 'Miktar',
                      installments: 'Taksit Sayısı',
                      reason: 'Talep Nedeni',
                      startDate: 'Başlangıç Tarihi',
                      endDate: 'Bitiş Tarihi',
                      izinTuru: 'İzin Türü',
                      talepEdenAdi: 'Talep Eden',
                      talepTarihi: 'Talep Tarihi',
                      izinBaslangic: 'İzin Başlangıç',
                      izinBitis: 'İzin Bitiş',
                      izinNedeni: 'İzin Nedeni'
                    };
                    
                    // Value mappings
                    const valueMap = {
                      is_gunu: 'Gün İçi Mesai (Hafta İçi)',
                      tatil: 'Tatil Mesaisi (Hafta Sonu/Resmi Tatil)',
                      overtime: 'Fazla Mesai',
                      advance: 'Avans',
                      leave: 'İzin',
                      yillik: 'Yıllık İzin',
                      mazeret: 'Ücretli İzin',
                      ucretsiz: 'Ücretsiz İzin'
                    };
                    
                    return Object.entries(formData)
                      .filter(([key, value]) => !hiddenFields.includes(key) && value !== null && value !== undefined && value !== '' && typeof value !== 'object')
                      .map(([key, value]) => {
                        const label = labelMap[key] || key;
                        let displayValue = valueMap[value] || value;
                        
                        // Format date values
                        if (key.toLowerCase().includes('tarih') || key.toLowerCase().includes('date') || key.toLowerCase().includes('baslangic') || key.toLowerCase().includes('bitis')) {
                          try {
                            const date = new Date(value);
                            if (!isNaN(date.getTime())) {
                              displayValue = date.toLocaleDateString('tr-TR');
                            }
                          } catch {
                            // Keep original value
                          }
                        }
                        
                        // Format number values
                        if (key === 'mesaiSaati') {
                          displayValue = `${value} saat`;
                        }
                        if (key === 'amount') {
                          displayValue = `${Number(value).toLocaleString('tr-TR')} ₺`;
                        }
                        
                        return (
                          <div key={key} className="flex justify-between items-center text-sm border-b border-[hsl(var(--border))] pb-2 last:border-0 last:pb-0">
                            <span className="text-[hsl(var(--muted-foreground))] font-medium">{label}:</span>
                            <span className="font-semibold text-[hsl(var(--foreground))]">{String(displayValue)}</span>
                          </div>
                        );
                      });
                  })()}
                </div>
              </div>

              {/* Uploaded Document */}
              {selectedRequest.form_data && (() => {
                const formData = selectedRequest.form_data.form_data || selectedRequest.form_data;
                const fileData = formData.mesaiFormDosya || formData.uploaded_file || selectedRequest.form_data.uploaded_file;
                if (!fileData) return null;
                
                return (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
                    <FileCheck className="h-4 w-4" />
                    Yüklenen Belge
                  </Label>
                  <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-blue-100 rounded">
                        <FileText className="h-5 w-5 text-blue-600" />
                      </div>
                      <div>
                        <p className="font-medium text-sm">Islak İmzalı Form</p>
                        <p className="text-xs text-gray-500">
                          {fileData?.includes('image/png') ? 'PNG Resim' : 
                           fileData?.includes('image/jpeg') || fileData?.includes('image/jpg') ? 'JPEG Resim' : 
                           fileData?.includes('application/pdf') ? 'PDF Dosyası' : 'Belge'}
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <Button 
                        size="sm" 
                        variant="outline"
                        onClick={() => {
                          if (fileData) {
                            const newWindow = window.open();
                            if (newWindow) {
                              if (fileData.startsWith('data:image/')) {
                                newWindow.document.write(`<html><head><title>Belge Önizleme</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh;background:#f0f0f0;"><img src="${fileData}" style="max-width:100%;max-height:100vh;object-fit:contain;" /></body></html>`);
                              } else if (fileData.startsWith('data:application/pdf')) {
                                newWindow.document.write(`<html><head><title>PDF Önizleme</title></head><body style="margin:0;"><iframe src="${fileData}" style="width:100%;height:100vh;border:none;"></iframe></body></html>`);
                              } else {
                                newWindow.location.href = fileData;
                              }
                            }
                          }
                        }}
                      >
                        <Eye className="h-4 w-4 mr-1" />
                        Görüntüle
                      </Button>
                      <Button 
                        size="sm" 
                        variant="default"
                        onClick={() => {
                          if (fileData) {
                            const link = document.createElement('a');
                            link.href = fileData;
                            let ext = 'pdf';
                            if (fileData.includes('image/png')) ext = 'png';
                            else if (fileData.includes('image/jpeg') || fileData.includes('image/jpg')) ext = 'jpg';
                            link.download = `form_${selectedRequest.form_number || 'belge'}.${ext}`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }
                        }}
                      >
                        <Download className="h-4 w-4 mr-1" />
                        İndir
                      </Button>
                    </div>
                  </div>
                </div>
                );
              })()}

              {/* İzin Belgeleri */}
              {selectedRequest.form_data && (() => {
                const formData = selectedRequest.form_data.form_data || selectedRequest.form_data;
                const izinBelgeleri = formData.izinBelgeleri || [];
                if (izinBelgeleri.length === 0) return null;
                
                return (
                  <div className="border-t pt-4">
                    <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
                      <FileCheck className="h-4 w-4" />
                      İzin Belgeleri ({izinBelgeleri.length} dosya)
                    </Label>
                    <div className="mt-2 space-y-2">
                      {izinBelgeleri.map((belge, idx) => (
                        <div key={idx} className="p-3 bg-cyan-50 border border-cyan-200 rounded-lg flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-cyan-100 rounded">
                              <FileText className="h-5 w-5 text-cyan-600" />
                            </div>
                            <div>
                              <p className="font-medium text-sm">{belge.name}</p>
                              <p className="text-xs text-gray-500">
                                {belge.type || 'Belge'}
                              </p>
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <Button 
                              size="sm" 
                              variant="outline"
                              onClick={() => {
                                const newWindow = window.open();
                                if (newWindow) {
                                  if (belge.data.startsWith('data:image/')) {
                                    newWindow.document.write(`<html><head><title>Belge Önizleme</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh;background:#f0f0f0;"><img src="${belge.data}" style="max-width:100%;max-height:100vh;object-fit:contain;" /></body></html>`);
                                  } else if (belge.data.startsWith('data:application/pdf')) {
                                    newWindow.document.write(`<html><head><title>PDF Önizleme</title></head><body style="margin:0;"><iframe src="${belge.data}" style="width:100%;height:100vh;border:none;"></iframe></body></html>`);
                                  } else {
                                    newWindow.location.href = belge.data;
                                  }
                                }
                              }}
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Görüntüle
                            </Button>
                            <Button 
                              size="sm" 
                              variant="default"
                              onClick={() => {
                                const link = document.createElement('a');
                                link.href = belge.data;
                                link.download = belge.name;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                            >
                              <Download className="h-4 w-4 mr-1" />
                              İndir
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Genel Ek Belgeler */}
              {(() => {
                // Tüm olası belge kaynaklarını topla
                const allDocuments = [];
                
                // 1. documents array
                if (selectedRequest.documents && Array.isArray(selectedRequest.documents)) {
                  allDocuments.push(...selectedRequest.documents);
                }
                
                // 2. form_data.belgeler
                if (selectedRequest.form_data) {
                  const formData = selectedRequest.form_data.form_data || selectedRequest.form_data;
                  if (formData.belgeler && Array.isArray(formData.belgeler)) {
                    allDocuments.push(...formData.belgeler);
                  }
                  // avansBelgeleri için
                  if (formData.avansBelgeleri && Array.isArray(formData.avansBelgeleri)) {
                    allDocuments.push(...formData.avansBelgeleri);
                  }
                  // mesaiBelgeleri için
                  if (formData.mesaiBelgeleri && Array.isArray(formData.mesaiBelgeleri)) {
                    allDocuments.push(...formData.mesaiBelgeleri);
                  }
                }
                
                // izinBelgeleri zaten yukarıda gösterildi, tekrar ekleme
                if (allDocuments.length === 0) return null;
                
                return (
                  <div className="border-t pt-4">
                    <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
                      <FileText className="h-4 w-4" />
                      Ek Belgeler ({allDocuments.length} dosya)
                    </Label>
                    <div className="mt-2 space-y-2">
                      {allDocuments.map((belge, idx) => (
                        <div key={idx} className="p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-amber-100 rounded">
                              <FileText className="h-5 w-5 text-amber-600" />
                            </div>
                            <div>
                              <p className="font-medium text-sm">{belge.name || `Belge ${idx + 1}`}</p>
                              <p className="text-xs text-gray-500">
                                {belge.type || 'Belge'}
                              </p>
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <Button 
                              size="sm" 
                              variant="outline"
                              onClick={() => {
                                const newWindow = window.open();
                                if (newWindow) {
                                  const data = belge.data || belge.url || belge;
                                  if (typeof data === 'string') {
                                    if (data.startsWith('data:image/')) {
                                      newWindow.document.write(`<html><head><title>Belge Önizleme</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh;background:#f0f0f0;"><img src="${data}" style="max-width:100%;max-height:100vh;object-fit:contain;" /></body></html>`);
                                    } else if (data.startsWith('data:application/pdf')) {
                                      newWindow.document.write(`<html><head><title>PDF Önizleme</title></head><body style="margin:0;"><iframe src="${data}" style="width:100%;height:100vh;border:none;"></iframe></body></html>`);
                                    } else {
                                      newWindow.location.href = data;
                                    }
                                  }
                                }
                              }}
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Görüntüle
                            </Button>
                            <Button 
                              size="sm" 
                              variant="default"
                              onClick={() => {
                                const data = belge.data || belge.url || belge;
                                if (typeof data === 'string') {
                                  const link = document.createElement('a');
                                  link.href = data;
                                  const ext = (belge.type || '').split('/')[1] || 'file';
                                  link.download = belge.name || `belge_${idx + 1}.${ext}`;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                }
                              }}
                            >
                              <Download className="h-4 w-4 mr-1" />
                              İndir
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Branch Approval Info */}
              {selectedRequest.branch_approval && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Şube Onayı</Label>
                  <div className="mt-2 bg-blue-50 p-3 rounded text-sm">
                    <p><strong>İleten:</strong> {selectedRequest.branch_approval.forwarded_by_name}</p>
                    {selectedRequest.branch_approval.note && (
                      <p><strong>Not:</strong> {selectedRequest.branch_approval.note}</p>
                    )}
                    <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                      {formatDate(selectedRequest.branch_approval.timestamp)}
                    </p>
                  </div>
                </div>
              )}

              {/* HR Approval Info */}
              {selectedRequest.hr_approval && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">İK İşlemi</Label>
                  <div className={`mt-2 p-3 rounded text-sm ${selectedRequest.hr_approval.approved ? 'bg-green-50' : 'bg-purple-50'}`}>
                    <p><strong>{selectedRequest.hr_approval.approved ? 'Onaylayan' : 'İleten'}:</strong> {selectedRequest.hr_approval.approved_by_name || selectedRequest.hr_approval.forwarded_by_name}</p>
                    {selectedRequest.hr_approval.note && (
                      <p><strong>Not:</strong> {selectedRequest.hr_approval.note}</p>
                    )}
                    <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                      {formatDate(selectedRequest.hr_approval.timestamp)}
                    </p>
                  </div>
                </div>
              )}

              {/* HR Rejection Info */}
              {selectedRequest.hr_rejection && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">İK Reddi</Label>
                  <div className="mt-2 bg-red-50 p-3 rounded text-sm">
                    <p><strong>Reddeden:</strong> {selectedRequest.hr_rejection.rejected_by_name}</p>
                    {selectedRequest.hr_rejection.reason && (
                      <p><strong>Red Nedeni:</strong> {selectedRequest.hr_rejection.reason}</p>
                    )}
                    <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                      {formatDate(selectedRequest.hr_rejection.timestamp)}
                    </p>
                  </div>
                </div>
              )}

              {/* Management Approval Info */}
              {selectedRequest.management_approval && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Yönetim Onayı</Label>
                  <div className="mt-2 bg-green-50 p-3 rounded text-sm">
                    <p><strong>Onaylayan:</strong> {selectedRequest.management_approval.approved_by_name}</p>
                    {selectedRequest.management_approval.note && (
                      <p><strong>Not:</strong> {selectedRequest.management_approval.note}</p>
                    )}
                    <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                      {formatDate(selectedRequest.management_approval.timestamp)}
                    </p>
                  </div>
                </div>
              )}

              {/* Management Rejection Info */}
              {selectedRequest.management_rejection && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Yönetim Reddi</Label>
                  <div className="mt-2 bg-red-50 p-3 rounded text-sm">
                    <p><strong>Reddeden:</strong> {selectedRequest.management_rejection.rejected_by_name}</p>
                    {selectedRequest.management_rejection.reason && (
                      <p><strong>Red Nedeni:</strong> {selectedRequest.management_rejection.reason}</p>
                    )}
                    <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                      {formatDate(selectedRequest.management_rejection.timestamp)}
                    </p>
                  </div>
                </div>
              )}

              {/* Action History - Detaylı İşlem Geçmişi */}
              {selectedRequest.action_history && selectedRequest.action_history.length > 0 && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2 mb-3">
                    <History className="h-4 w-4" />
                    İşlem Geçmişi
                  </Label>
                  <div className="space-y-3">
                    {selectedRequest.action_history.map((action, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <div className={`w-3 h-3 rounded-full mt-1.5 flex-shrink-0 ${
                          action.action === 'created' ? 'bg-blue-500' :
                          action.action === 'approved' ? 'bg-green-500' :
                          action.action === 'rejected' ? 'bg-red-500' :
                          action.action === 'forwarded' ? 'bg-purple-500' :
                          'bg-gray-400'
                        }`} />
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="font-medium text-sm">{action.user_name || 'Sistem'}</span>
                            <Badge variant="outline" className="text-xs">
                              {action.action === 'created' ? 'Oluşturdu' :
                               action.action === 'approved' ? 'Onayladı' :
                               action.action === 'rejected' ? 'Reddetti' :
                               action.action === 'forwarded' ? 'İletti' :
                               action.action}
                            </Badge>
                            {action.target && (
                              <span className="text-xs text-gray-500">
                                → {action.target === 'ik' ? 'İK' :
                                   action.target === 'yonetim' ? 'Yönetim' :
                                   action.target === 'muhasebe' ? 'Muhasebe' :
                                   action.target === 'satin_alma' ? 'Satın Alma' :
                                   action.target}
                              </span>
                            )}
                          </div>
                          {action.note && (
                            <p className="text-sm text-gray-600 mt-1">{action.note}</p>
                          )}
                          <p className="text-xs text-gray-400 mt-1">
                            {formatDate(action.timestamp)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Status History - Eski format desteği */}
              {selectedRequest.status_history && selectedRequest.status_history.length > 0 && !selectedRequest.action_history && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">İşlem Geçmişi</Label>
                  <div className="mt-2 space-y-2">
                    {selectedRequest.status_history.map((history, idx) => (
                      <div key={idx} className="text-xs bg-[hsl(var(--muted))] p-2 rounded flex justify-between">
                        <span>{history.note}</span>
                        <span className="text-[hsl(var(--muted-foreground))]">{formatDate(history.timestamp)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          
          <DialogFooter className="gap-2">
            {selectedRequest?.status === 'pending_hr' && (
              <>
                <Button 
                  variant="destructive" 
                  onClick={() => openActionModal('reject')}
                  disabled={loading}
                >
                  <XCircle className="h-4 w-4 mr-2" />
                  Red Et
                </Button>
                {(selectedRequest?.form_type === 'overtime' || selectedRequest?.form_template_id === 'overtime') ? (
                  <Button 
                    onClick={() => openActionModal('approve_overtime')}
                    disabled={loading}
                    className="bg-green-600 hover:bg-green-700"
                  >
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Onayla
                  </Button>
                ) : selectedRequest?.form_template_id === 'leave' ? (
                  <Button 
                    onClick={() => openLeaveApprovalModal(selectedRequest)}
                    disabled={loading}
                    className="bg-green-600 hover:bg-green-700"
                  >
                    <Calendar className="h-4 w-4 mr-2" />
                    Günleri Seç ve Onayla
                  </Button>
                ) : (
                  <>
                    <Button 
                      onClick={() => openActionModal('hr_approve')}
                      disabled={loading}
                      className="bg-green-600 hover:bg-green-700"
                    >
                      <CheckCircle className="h-4 w-4 mr-2" />
                      Onayla
                    </Button>
                    <Button 
                      onClick={() => openActionModal('forward_management')}
                      disabled={loading}
                      className="bg-purple-600 hover:bg-purple-700"
                    >
                      <Send className="h-4 w-4 mr-2" />
                      Onayla ve Yönetime İlet
                    </Button>
                  </>
                )}
              </>
            )}
            <Button variant="outline" onClick={() => setDetailModalOpen(false)}>
              Kapat
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Action Modal */}
      <Dialog open={showActionModal} onOpenChange={setShowActionModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {actionType === 'forward_management' ? 'Onayla ve Yönetime İlet' : 
               actionType === 'hr_approve' ? 'Talebi Onayla' :
               actionType === 'approve_overtime' ? 'Fazla Mesaiyi Onayla' : 'Talebi Reddet'}
            </DialogTitle>
            <DialogDescription>
              {actionType === 'forward_management' 
                ? 'Talebi onaylayıp yönetime iletmeden önce not ekleyebilirsiniz.'
                : actionType === 'hr_approve'
                ? 'Talebi İK olarak onaylayın. Not ekleyebilirsiniz.'
                : actionType === 'approve_overtime'
                ? 'Talebi onaylayın ve fazla mesai tablosuna işleyin.'
                : 'Lütfen red nedenini belirtin.'}
            </DialogDescription>
          </DialogHeader>
          
          <div className="py-4">
            <Label htmlFor="actionNote">
              {actionType === 'reject' ? 'Red Nedeni *' : 'Not (İsteğe bağlı)'}
            </Label>
            <Textarea
              id="actionNote"
              value={actionNote}
              onChange={(e) => setActionNote(e.target.value)}
              placeholder={actionType === 'reject' ? 'Red nedenini yazın...' : 'Not ekleyin...'}
              className="mt-2"
              rows={4}
            />
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowActionModal(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleAction}
              disabled={loading || (actionType === 'reject' && !actionNote.trim())}
              className={actionType === 'forward_management' ? 'bg-purple-600 hover:bg-purple-700' : (actionType === 'approve_overtime' || actionType === 'hr_approve') ? 'bg-green-600 hover:bg-green-700' : ''}
              variant={actionType === 'reject' ? 'destructive' : 'default'}
            >
              {loading ? 'İşleniyor...' : (
                actionType === 'forward_management' ? 'Onayla ve İlet' : 
                actionType === 'hr_approve' ? 'Onayla' :
                actionType === 'approve_overtime' ? 'Onayla' : 'Reddet'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* İzin Günü Seçim Modalı */}
      <Dialog open={showLeaveDayModal} onOpenChange={setShowLeaveDayModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Calendar className="h-5 w-5 text-cyan-600" />
              İzin Günlerini Seç ve Onayla
            </DialogTitle>
            <DialogDescription>
              Mesai çizelgesine işlenecek izin günlerini seçin. Seçilen günler çalışanın puantaj tablosunda izinli olarak işaretlenecektir.
            </DialogDescription>
          </DialogHeader>
          
          {selectedRequest && (
            <div className="space-y-4">
              {/* Talep Bilgileri */}
              {(() => {
                // Handle nested form_data structure for display
                const displayFormData = selectedRequest.form_data?.form_data || selectedRequest.form_data || {};
                return (
                  <div className="p-4 bg-cyan-50 border border-cyan-200 rounded-lg space-y-2">
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="text-gray-500">Talep Eden:</span>
                        <span className="ml-2 font-medium">{selectedRequest.original_requester_name || selectedRequest.requester_name || selectedRequest.owner_name || 'Bilinmiyor'}</span>
                      </div>
                      <div>
                        <span className="text-gray-500">İzin Türü:</span>
                        <span className="ml-2 font-medium">
                          {displayFormData.izinTuru === 'yillik' ? 'Yıllık İzin' : 
                           displayFormData.izinTuru === 'mazeret' ? 'Ücretli İzin' : 'Ücretsiz İzin'}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500">Başlangıç:</span>
                        <span className="ml-2 font-medium">
                          {displayFormData.izinBaslangic ? new Date(displayFormData.izinBaslangic).toLocaleDateString('tr-TR') : '-'}
                        </span>
                      </div>
                      <div>
                        <span className="text-gray-500">Bitiş:</span>
                        <span className="ml-2 font-medium">
                          {displayFormData.izinBitis ? new Date(displayFormData.izinBitis).toLocaleDateString('tr-TR') : '-'}
                        </span>
                      </div>
                    </div>
                    {displayFormData.izinNedeni && (
                      <div className="text-sm border-t border-cyan-200 pt-2 mt-2">
                        <span className="text-gray-500">Neden:</span>
                        <p className="mt-1 text-gray-700">{displayFormData.izinNedeni}</p>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* Gün Seçimi */}
              <div>
                <Label className="text-sm font-medium mb-2 block">
                  İzinli Günleri Seçin ({selectedLeaveDays.length} gün seçildi)
                </Label>
                <div className="grid grid-cols-7 gap-2 p-4 bg-gray-50 rounded-lg border max-h-[300px] overflow-y-auto">
                  {(() => {
                    // Handle nested form_data structure
                    const formData = selectedRequest.form_data?.form_data || selectedRequest.form_data || {};
                    const startDate = formData.izinBaslangic;
                    const endDate = formData.izinBitis;
                    if (!startDate || !endDate) return (
                      <p className="col-span-7 text-center text-gray-500">Tarih bilgisi bulunamadı</p>
                    );
                    
                    const days = [];
                    const current = new Date(startDate);
                    const end = new Date(endDate);
                    
                    while (current <= end) {
                      const dayStr = current.toISOString().split('T')[0];
                      const isSelected = selectedLeaveDays.includes(dayStr);
                      const dayOfWeek = current.getDay();
                      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
                      
                      days.push(
                        <button
                          key={dayStr}
                          type="button"
                          onClick={() => toggleLeaveDay(dayStr)}
                          className={`p-2 rounded-lg text-center transition-all ${
                            isSelected 
                              ? 'bg-cyan-600 text-white shadow-md' 
                              : isWeekend 
                                ? 'bg-orange-100 text-orange-700 hover:bg-orange-200' 
                                : 'bg-white text-gray-700 hover:bg-cyan-100 border'
                          }`}
                        >
                          <div className="text-xs font-medium">
                            {['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'][current.getDay()]}
                          </div>
                          <div className="text-lg font-bold">{current.getDate()}</div>
                          <div className="text-xs">
                            {current.toLocaleDateString('tr-TR', { month: 'short' })}
                          </div>
                        </button>
                      );
                      current.setDate(current.getDate() + 1);
                    }
                    return days;
                  })()}
                </div>
                <div className="flex gap-2 mt-2">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      // Handle nested form_data structure
                      const btnFormData = selectedRequest.form_data?.form_data || selectedRequest.form_data || {};
                      const startDate = btnFormData.izinBaslangic;
                      const endDate = btnFormData.izinBitis;
                      if (startDate && endDate) {
                        const days = [];
                        const current = new Date(startDate);
                        const end = new Date(endDate);
                        while (current <= end) {
                          days.push(current.toISOString().split('T')[0]);
                          current.setDate(current.getDate() + 1);
                        }
                        setSelectedLeaveDays(days);
                      }
                    }}
                  >
                    Tümünü Seç
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      // Handle nested form_data structure
                      const btnFormData = selectedRequest.form_data?.form_data || selectedRequest.form_data || {};
                      const startDate = btnFormData.izinBaslangic;
                      const endDate = btnFormData.izinBitis;
                      if (startDate && endDate) {
                        const days = [];
                        const current = new Date(startDate);
                        const end = new Date(endDate);
                        while (current <= end) {
                          const dayOfWeek = current.getDay();
                          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                            days.push(current.toISOString().split('T')[0]);
                          }
                          current.setDate(current.getDate() + 1);
                        }
                        setSelectedLeaveDays(days);
                      }
                    }}
                  >
                    Sadece Hafta İçi
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => setSelectedLeaveDays([])}
                  >
                    Temizle
                  </Button>
                </div>
              </div>

              {/* Durum Seçimi */}
              <div>
                <Label className="text-sm font-medium mb-2 block">
                  Mesai Çizelgesine İşlenecek Durum
                </Label>
                <div className="grid grid-cols-4 gap-2">
                  {attendanceStatusOptions.map(option => (
                    <button
                      key={option.value}
                      type="button"
                      onClick={() => setSelectedAttendanceStatus(option.value)}
                      className={`p-2 rounded-lg text-center text-sm font-medium transition-all border-2 ${
                        selectedAttendanceStatus === option.value 
                          ? `${option.color} ring-2 ring-offset-1 ring-gray-400` 
                          : 'bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100'
                      }`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-2">
                  Seçilen günler mesai çizelgesinde "{attendanceStatusOptions.find(o => o.value === selectedAttendanceStatus)?.label}" olarak işaretlenecektir.
                </p>
              </div>

              {/* Not */}
              <div>
                <Label htmlFor="leaveNote">Not (İsteğe Bağlı)</Label>
                <Textarea
                  id="leaveNote"
                  value={actionNote}
                  onChange={(e) => setActionNote(e.target.value)}
                  placeholder="Onay notu ekleyin..."
                  rows={2}
                />
              </div>
            </div>
          )}
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowLeaveDayModal(false)}>
              İptal
            </Button>
            <Button 
              variant="destructive"
              onClick={() => {
                setShowLeaveDayModal(false);
                openActionModal('reject');
              }}
            >
              <XCircle className="h-4 w-4 mr-2" />
              Red Et
            </Button>
            <Button 
              onClick={() => {
                setActionType('approve_leave');
                handleAction();
              }}
              disabled={loading || selectedLeaveDays.length === 0}
              className="bg-green-600 hover:bg-green-700"
            >
              {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <CheckCircle className="h-4 w-4 mr-2" />}
              {selectedLeaveDays.length} Gün Onayla
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Toplu Silme Onay Dialog */}
      <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="h-5 w-5" />
              Talepleri Sil
            </AlertDialogTitle>
            <AlertDialogDescription>
              <strong>{selectedRequests.length}</strong> talep silinecek. Bu işlem geri alınamaz.
              <br />
              <span className="text-red-600 font-medium">Emin misiniz?</span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={deleteLoading}>İptal</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleBulkDelete}
              disabled={deleteLoading}
              className="bg-red-600 hover:bg-red-700"
            >
              {deleteLoading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Siliniyor...
                </>
              ) : (
                <>
                  <Trash2 className="h-4 w-4 mr-2" />
                  Evet, Sil
                </>
              )}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Belge Detay Modalı */}
      <Dialog open={docDetailModalOpen} onOpenChange={setDocDetailModalOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-3">
              <FileText className="h-5 w-5" />
              {selectedDocRequest?.title || 'Belge Talebi'}
            </DialogTitle>
            <DialogDescription>
              {selectedDocResponse ? 'Gelen belge detayları' : 'Bekleyen belge talebi detayları'}
            </DialogDescription>
          </DialogHeader>
          
          {selectedDocRequest && (
            <div className="space-y-4 py-4">
              {/* Talep Bilgileri */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Belge Başlığı</Label>
                  <p className="font-medium">{selectedDocRequest.title}</p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Gönderilme Tarihi</Label>
                  <p className="font-medium">
                    {selectedDocRequest.created_at ? new Date(selectedDocRequest.created_at).toLocaleDateString('tr-TR', {
                      day: '2-digit', month: '2-digit', year: 'numeric',
                      hour: '2-digit', minute: '2-digit'
                    }) : '-'}
                  </p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Hedef Çalışan Sayısı</Label>
                  <p className="font-medium">{(selectedDocRequest.target_employee_ids || []).length} kişi</p>
                </div>
                <div>
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Durum</Label>
                  <div className="mt-1">
                    {selectedDocResponse ? (
                      <Badge className="bg-green-100 text-green-800">Cevaplandı</Badge>
                    ) : (
                      <Badge variant="outline" className="bg-yellow-100 text-yellow-800">Bekliyor</Badge>
                    )}
                  </div>
                </div>
              </div>

              {/* Açıklama */}
              {selectedDocRequest.description && (
                <div className="border-t pt-4">
                  <Label className="text-xs text-[hsl(var(--muted-foreground))]">Açıklama</Label>
                  <p className="mt-1 text-sm bg-[hsl(var(--muted))] p-3 rounded-lg">{selectedDocRequest.description}</p>
                </div>
              )}

              {/* Cevap Bilgileri (Gelen Belge için) */}
              {selectedDocResponse && (
                <>
                  <div className="border-t pt-4">
                    <Label className="text-xs text-[hsl(var(--muted-foreground))]">Cevap Veren</Label>
                    <p className="font-medium">{selectedDocResponse.employee_name || selectedDocResponse.employeeId}</p>
                    {selectedDocResponse.responded_at && (
                      <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
                        Cevap Tarihi: {new Date(selectedDocResponse.responded_at).toLocaleDateString('tr-TR', {
                          day: '2-digit', month: '2-digit', year: 'numeric',
                          hour: '2-digit', minute: '2-digit'
                        })}
                      </p>
                    )}
                  </div>

                  {/* Cevap Notu */}
                  {selectedDocResponse.note && (
                    <div className="border-t pt-4">
                      <Label className="text-xs text-[hsl(var(--muted-foreground))]">Çalışan Notu</Label>
                      <p className="mt-1 text-sm bg-blue-50 p-3 rounded-lg border border-blue-200">{selectedDocResponse.note}</p>
                    </div>
                  )}

                  {/* Gönderilen Belgeler */}
                  {selectedDocResponse.documents && selectedDocResponse.documents.length > 0 && (
                    <div className="border-t pt-4">
                      <Label className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
                        <FileCheck className="h-4 w-4" />
                        Gönderilen Belgeler ({selectedDocResponse.documents.length} dosya)
                      </Label>
                      <div className="mt-2 space-y-2">
                        {selectedDocResponse.documents.map((doc, idx) => (
                          <div key={idx} className="p-3 bg-green-50 border border-green-200 rounded-lg flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <div className="p-2 bg-green-100 rounded">
                                <FileText className="h-5 w-5 text-green-600" />
                              </div>
                              <div>
                                <p className="font-medium text-sm">{doc.name || `Belge ${idx + 1}`}</p>
                                <p className="text-xs text-gray-500">
                                  {doc.data?.includes('image/png') ? 'PNG Resim' : 
                                   doc.data?.includes('image/jpeg') || doc.data?.includes('image/jpg') ? 'JPEG Resim' : 
                                   doc.data?.includes('application/pdf') ? 'PDF Dosyası' : 'Belge'}
                                </p>
                              </div>
                            </div>
                            <div className="flex gap-2">
                              <Button 
                                size="sm" 
                                variant="outline"
                                onClick={() => {
                                  const fileData = doc.data;
                                  if (fileData) {
                                    const newWindow = window.open();
                                    if (newWindow) {
                                      if (fileData.startsWith('data:image/')) {
                                        newWindow.document.write(`<html><head><title>Belge Önizleme</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh;background:#f0f0f0;"><img src="${fileData}" style="max-width:100%;max-height:100vh;object-fit:contain;" /></body></html>`);
                                      } else if (fileData.startsWith('data:application/pdf')) {
                                        newWindow.document.write(`<html><head><title>PDF Önizleme</title></head><body style="margin:0;"><iframe src="${fileData}" style="width:100%;height:100vh;border:none;"></iframe></body></html>`);
                                      } else {
                                        newWindow.location.href = fileData;
                                      }
                                    }
                                  }
                                }}
                              >
                                <Eye className="h-4 w-4 mr-1" />
                                Görüntüle
                              </Button>
                              <Button 
                                size="sm" 
                                variant="default"
                                onClick={() => {
                                  const fileData = doc.data;
                                  if (fileData) {
                                    const link = document.createElement('a');
                                    link.href = fileData;
                                    let ext = 'pdf';
                                    if (fileData.includes('image/png')) ext = 'png';
                                    else if (fileData.includes('image/jpeg') || fileData.includes('image/jpg')) ext = 'jpg';
                                    link.download = doc.name || `belge_${idx + 1}.${ext}`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                  }
                                }}
                              >
                                <Download className="h-4 w-4 mr-1" />
                                İndir
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Belgeler yoksa */}
                  {(!selectedDocResponse.documents || selectedDocResponse.documents.length === 0) && (
                    <div className="border-t pt-4">
                      <div className="text-center py-8 bg-gray-50 rounded-lg">
                        <FileText className="h-12 w-12 mx-auto mb-2 text-gray-300" />
                        <p className="text-gray-500">Henüz belge yüklenmemiş</p>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Bekleyen Talep için (cevap yok) */}
              {!selectedDocResponse && (
                <div className="border-t pt-4">
                  <div className="text-center py-8 bg-yellow-50 rounded-lg border border-yellow-200">
                    <Loader2 className="h-12 w-12 mx-auto mb-2 text-yellow-500 animate-spin" />
                    <p className="text-yellow-700 font-medium">Çalışan cevabı bekleniyor</p>
                    <p className="text-sm text-yellow-600 mt-1">Hedef çalışanlardan henüz cevap gelmedi</p>
                  </div>
                </div>
              )}
            </div>
          )}
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setDocDetailModalOpen(false)}>
              Kapat
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Talep Oluşturma Modalı */}
      <Dialog open={createRequestModalOpen} onOpenChange={setCreateRequestModalOpen}>
        <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Plus className="h-5 w-5 text-violet-600" />
              Yeni Talep Oluştur
            </DialogTitle>
            <DialogDescription>
              Talep bilgilerini doldurun ve gönderin
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Talep Tarihi */}
            <div className="space-y-2">
              <Label>Talep Tarihi *</Label>
              <Input
                type="date"
                value={newRequestData.request_date}
                onChange={(e) => setNewRequestData(prev => ({ ...prev, request_date: e.target.value }))}
                data-testid="request-date"
              />
            </div>

            {/* İş Konusu - Dosya adından otomatik */}
            <div className="space-y-2">
              <Label>İş Konusu <span className="text-xs text-gray-500">(Belge yüklendiğinde otomatik dolar)</span></Label>
              <Input
                placeholder="Belge yükleyin..."
                value={newRequestData.title}
                readOnly
                className="bg-gray-50"
                data-testid="request-title"
              />
            </div>

            {/* Açıklama */}
            <div className="space-y-2">
              <Label>Açıklama *</Label>
              <Textarea
                placeholder="Talep açıklamanızı yazın..."
                value={newRequestData.description}
                onChange={(e) => setNewRequestData(prev => ({ ...prev, description: e.target.value }))}
                rows={4}
                data-testid="request-description"
              />
            </div>

            {/* Belgeler */}
            <div className="space-y-2">
              <Label className="flex items-center gap-2 text-amber-700">
                <FileIcon className="h-4 w-4" />
                Belge Yükle *
              </Label>
              <div className="border-2 border-dashed border-amber-300 rounded-lg p-4 bg-amber-50">
                <input
                  type="file"
                  multiple
                  onChange={handleDocumentSelect}
                  className="hidden"
                  id="request-documents"
                />
                <label htmlFor="request-documents" className="cursor-pointer flex flex-col items-center">
                  <FileIcon className="h-8 w-8 mb-2 text-amber-500" />
                  <p className="text-sm text-amber-700 font-medium">Belge eklemek için tıklayın</p>
                </label>
              </div>
              {pendingDocuments.length > 0 && (
                <div className="space-y-2 mt-2">
                  {pendingDocuments.map((file, index) => (
                    <div key={index} className="flex items-center justify-between bg-amber-50 p-2 rounded border border-amber-200">
                      <div className="flex items-center gap-2">
                        <FileIcon className="h-4 w-4 text-amber-600" />
                        <span className="text-sm font-medium truncate max-w-[200px]">{file.name}</span>
                      </div>
                      <Button variant="ghost" size="sm" onClick={() => removeDocument(index)}>
                        <XCircle className="h-4 w-4 text-red-500" />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Gönderilecek Kişiler (Çoklu Seçim) */}
            <div className="space-y-2">
              <Label>Gönderilecek Kişiler * <span className="text-xs text-gray-500">(Birden fazla seçebilirsiniz)</span></Label>
              <Input
                placeholder="Kişi ara..."
                value={requestUserSearchTerm}
                onChange={(e) => setRequestUserSearchTerm(e.target.value)}
                className="mb-2"
              />
              <ScrollArea className="h-[180px] border rounded-md p-2">
                {loadingRequestUsers ? (
                  <div className="flex items-center justify-center py-4">
                    <Loader2 className="h-5 w-5 animate-spin text-violet-500" />
                  </div>
                ) : (
                  <div className="space-y-1">
                    {filteredRequestTargetUsers.map(user => (
                      <div
                        key={user.id}
                        className={`p-2 rounded cursor-pointer hover:bg-gray-100 flex items-center gap-2 ${
                          newRequestData.target_user_ids.includes(user.id) ? 'bg-violet-50 border border-violet-200' : ''
                        }`}
                        onClick={() => toggleUserSelection(user.id)}
                      >
                        <div className={`w-5 h-5 border rounded flex items-center justify-center ${
                          newRequestData.target_user_ids.includes(user.id) 
                            ? 'bg-violet-600 border-violet-600' 
                            : 'border-gray-300'
                        }`}>
                          {newRequestData.target_user_ids.includes(user.id) && (
                            <CheckCircle className="h-4 w-4 text-white" />
                          )}
                        </div>
                        <User className="h-4 w-4 text-gray-500" />
                        <div className="flex-1">
                          <p className="text-sm font-medium">{user.name}</p>
                          <p className="text-xs text-gray-500">{user.position || user.email}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </ScrollArea>
              {newRequestData.target_user_ids.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {newRequestData.target_user_ids.map(userId => {
                    const user = requestTargetUsers.find(u => u.id === userId);
                    return user ? (
                      <span key={userId} className="inline-flex items-center gap-1 px-2 py-1 bg-violet-100 text-violet-700 rounded-full text-xs">
                        {user.name}
                        <XCircle 
                          className="h-3 w-3 cursor-pointer hover:text-violet-900" 
                          onClick={() => toggleUserSelection(userId)}
                        />
                      </span>
                    ) : null;
                  })}
                </div>
              )}
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setCreateRequestModalOpen(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleCreateRequest}
              disabled={submittingRequest}
              className="bg-violet-600 hover:bg-violet-700"
              data-testid="submit-request-btn"
            >
              {submittingRequest ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Gönderiliyor...
                </>
              ) : (
                <>
                  <Send className="h-4 w-4 mr-2" />
                  Talep Gönder
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Talep Detay Modalı */}
      <Dialog open={myRequestDetailModalOpen} onOpenChange={setMyRequestDetailModalOpen}>
        <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileIcon className="h-5 w-5 text-violet-600" />
              Talep Detayı
            </DialogTitle>
            {selectedMyRequest?.request_no && (
              <DialogDescription>
                Talep No: {selectedMyRequest.request_no}
              </DialogDescription>
            )}
          </DialogHeader>
          
          {selectedMyRequest && (
            <div className="space-y-4 py-4">
              {/* Tarih ve Durum */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-gray-500 text-xs">Talep Tarihi</Label>
                  <p className="font-medium">
                    {selectedMyRequest.request_date 
                      ? new Date(selectedMyRequest.request_date).toLocaleDateString('tr-TR')
                      : new Date(selectedMyRequest.created_at).toLocaleDateString('tr-TR')}
                  </p>
                </div>
                <div>
                  <Label className="text-gray-500 text-xs">Durum</Label>
                  <Badge variant="outline" className={
                    selectedMyRequest.status === 'approved' ? 'bg-green-100 text-green-800' :
                    selectedMyRequest.status === 'rejected' ? 'bg-red-100 text-red-800' :
                    'bg-yellow-100 text-yellow-800'
                  }>
                    {selectedMyRequest.status === 'approved' ? 'Onaylandı' :
                     selectedMyRequest.status === 'rejected' ? 'Reddedildi' : 'Bekliyor'}
                  </Badge>
                </div>
              </div>

              {/* Başlık */}
              <div>
                <Label className="text-gray-500 text-xs">Başlık</Label>
                <p className="font-medium">{selectedMyRequest.title}</p>
              </div>

              {/* Açıklama */}
              <div>
                <Label className="text-gray-500 text-xs">Açıklama</Label>
                <p className="text-sm text-gray-700 whitespace-pre-wrap bg-gray-50 p-3 rounded-md">
                  {selectedMyRequest.description || '-'}
                </p>
              </div>

              {/* Gönderildiği Kişiler */}
              <div>
                <Label className="text-gray-500 text-xs">Gönderildiği Kişiler</Label>
                <div className="flex flex-wrap gap-2 mt-1">
                  {selectedMyRequest.target_user_names?.map((name, idx) => (
                    <Badge key={idx} className="bg-violet-100 text-violet-800">
                      <User className="h-3 w-3 mr-1" />
                      {name}
                    </Badge>
                  )) || <span className="text-gray-500">-</span>}
                </div>
              </div>

              {/* Belgeler */}
              {selectedMyRequest.documents && selectedMyRequest.documents.length > 0 && (
                <div>
                  <Label className="text-gray-500 text-xs">Belgeler ({selectedMyRequest.documents.length})</Label>
                  <div className="space-y-2 mt-2">
                    {selectedMyRequest.documents.map((doc, idx) => (
                      <div key={idx} className="flex items-center justify-between bg-gray-50 p-2 rounded border">
                        <div className="flex items-center gap-2">
                          <FileIcon className="h-4 w-4 text-gray-500" />
                          <span className="text-sm">{doc.name}</span>
                        </div>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={async () => {
                            try {
                              const token = localStorage.getItem('fortis_token');
                              const response = await fetch(`${API}/hr/requests/documents/${doc.id}/download`, {
                                headers: { 'Authorization': `Bearer ${token}` }
                              });
                              if (response.ok) {
                                const blob = await response.blob();
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = doc.name;
                                document.body.appendChild(a);
                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();
                              } else {
                                toast.error('Dosya indirilemedi');
                              }
                            } catch (error) {
                              toast.error('Dosya indirilemedi');
                            }
                          }}
                          className="text-violet-600"
                        >
                          <Download className="h-4 w-4 mr-1" />
                          İndir
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Oluşturulma Bilgisi */}
              <div className="text-xs text-gray-400 border-t pt-3">
                Oluşturulma: {new Date(selectedMyRequest.created_at).toLocaleString('tr-TR')}
              </div>
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setMyRequestDetailModalOpen(false)}>
              Kapat
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Communications;
